import { AbstractControl, ValidatorFn } from '@angular/forms';

export function validatePhoneNumberLength(ctrl: AbstractControl) {
    if (ctrl.value) {
        const phoneNumber = ctrl.value.replace(/[^0-9]/gim, '');
        if (phoneNumber.length < 11) {
            return { invalidPhoneNumberLength: true };
        }
    }
    return null;
}
